'use strict';

class Colors {
 
  constructor() {
    const colors = ['orange', 'blue', 'yellow', 'green', 'lightgreen', 'red', 'aqua', 'lila'];
    this.topColors = this.mergeObject(colors); //Object.assign([], colors);
    this.bottomColors = this.mergeObject(colors); //Object.assign([], colors);
  }

   mergeObject(target) {
    for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key];
            }
        }
    }
    return target;
  }
  
  getTopColor() {
    if (this.topColors.length === 0) {
      return '';
    }

    const index = this.randomNumber(this.topColors.length);
    const color = this.topColors[index];
    this.topColors.splice(index, 1);

    return color;
  }

  getBottomColor() {
    if (this.bottomColors.length === 0) {
      return '';
    }

    const index = this.randomNumber(this.topColors.length);
    const color = this.bottomColors[index];
    this.bottomColors.splice(index, 1);

    return color;
  }

  randomNumber(length) {
    return Math.floor(Math.random() * length);
  }
}
